module.exports = __webpack_public_path__ + "static/media/icon_arrow_select.25aab728.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_arrow_select.svg
// module id = 615
// module chunks = 0